<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Apply Bank Account') }}</h3>
                <span class="fz-16 fw-400">{{ $t('Create an account tailored to your needs') }}</span>
            </div>

            <step-container
                :current_step="4"
                :step_list="stepList"
            ></step-container>
        </div>
        <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col xl="12">
                        <div class="p-0" v-if="init">
                            <div class="mb-5 p-3">
                                <div class="d-flex">
                                    <h5>{{ $t('Director Information') }}</h5>
                                </div>
                                
                                <div class="mb-3 mt-3">
                                    <div v-for="(item,index) in director_list" :key="item.id">
                                        <InterDirectorInfo
                                            :ref="'director'+item.id"
                                            @file-uploaded = "fileUploaded"
                                            :information = information
                                            :account_id = account_id
                                            :user_no = user_no
                                            :index="index"
                                            :is_new="item.is_new"
                                            @on-error = "onError"
                                            :doc_type_list = document
                                            :is_remove = "director_list.length>1?true:false">
                                        </InterDirectorInfo>
                                        <div class="d-flex justify-content-end mb-4">
                                            <div class="ml-auto d-flex">
                                                <button v-if="director_list.length>1" class="d-flex align-items-center btn btn-outline-red" @click="removeItemDirector(item.id)">
                                                    <span>Remove</span>
                                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                                </button>
                                                <button class="btn btn-outline-orange" @click="addDirector">{{ $t('Add') }} +</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="d-flex">
                        <router-link to="/international-registered-address" class="btn btn-previous d-block mr-auto" tag="button">{{ $t('Previous') }}</router-link>
                        <button @click="nextStep" class="ml-auto btn btn-primary d-block">{{ $t('Next Step') }}</button>
                    </b-col>
                </b-row>
            </div>
      </b-container>
      <LoaderComponent v-if="isLoading || (isLoading === false && init === false)"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import InterDirectorInfo from "@/components/CardManagement/interDirectorInfo";
    import CreateAccount from '@/services/CreateAccount';
    import Account from '@/services/Account';
  
    export default {
        name: 'international-director-info',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                init : false,
                director_list:[{"id":1}],
                document:[
                {
                        "id":2,
                        "name":"Passport"
                    },
                    {
                        "id":3,
                        "name":"Hong Kong Permanent ID Card"
                    },
                    {
                        "id":4,
                        "name":"Hong Kong ID Card"
                    },
                    {
                        "id":5,
                        "name":"Other Country Citizen ID Card"
                    }
                ],
                account_id : '',
                user_no : '',
                information : '',
                stepList:["Company Info","Business Address", "Registered Address", "Director Info","Beneficiary Info"]
            }
        },
        components: {
            LoaderComponent,
            stepContainer,
            InterDirectorInfo
        },
        methods:{
            fileUploaded(){
                let is_upload = true;
                for(let i=0;i<this.director_list.length;i++){
                    let ref = 'director'+this.director_list[i].id;
                    if(this.$refs[ref][0].success === false || this.$refs[ref][0].success === null){
                        is_upload = false;
                    }
                }

                if(is_upload){
                    let params = {
                        "accountId":this.account_id,
                        "userNo":""+this.user_no,
                        "directorName":[],
                        "directorBirthDate":[],
                        "directorIdNo":[],
                        "directorIdType":[],
                        "directorIdFront":[],
                        "directorIdReverse":[],
                        "directorIdHold":[],
                        "directorCertExpiryDate":[],
                        "directorCountryCode":[],
                        "directorProvince":[],
                        "directorCity":[],
                        "directorArea":[],
                        "directorAddress":[]
                    }

                    for(let i=0;i<this.director_list.length;i++){
                        let ref = 'director'+this.director_list[i].id;
                        
                        params['directorCountryCode'].push(this.$refs[ref][0].params.directorCountryCode);
                        params['directorIdType'].push(parseInt(this.$refs[ref][0].params.directorIdType));
                        params['directorIdFront'].push(this.$refs[ref][0].file.directorIdFront);
                        params['directorIdReverse'].push(this.$refs[ref][0].file.directorIdReverse);
                        params['directorIdHold'].push(this.$refs[ref][0].file.directorIdHold);
                        params['directorIdNo'].push(this.$refs[ref][0].params.directorIdNo);
                        params['directorName'].push(this.$refs[ref][0].params.directorName);
                        params['directorBirthDate'].push(this.$refs[ref][0].params.directorBirthDate);
                        params['directorCertExpiryDate'].push(this.$refs[ref][0].params.directorCertExpiryDate);
                        params['directorProvince'].push(this.$refs[ref][0].params.directorProvince);
                        params['directorCity'].push(this.$refs[ref][0].params.directorCity);
                        params['directorArea'].push(null);
                        params['directorAddress'].push(this.$refs[ref][0].params.directorAddress);
                    }
                    
                    Account.updateInternational(params).then(response => {
                        const data = response.data.data;
                        this.isLoading = false;
                        this.$router.push({ 
                            name: 'international-beneficiary-info'
                        });
                    });
                }
                
            },
            addDirector(){
                this.director_list.push({"id":(this.director_list[this.director_list.length-1].id+1)});
            },
            removeItemDirector(id) {
                const index = this.director_list.findIndex(item => item.id === id)
                if (index !== -1) {
                    this.director_list.splice(index, 1)
                }
            },
            onError(){
                this.isLoading = false;
            },
            nextStep(){
                this.isLoading = true;
                let is_valid = true;

                for(let i=0;i<this.director_list.length;i++){
                    let ref = 'director'+this.director_list[i].id;
                    if(!this.$refs[ref][0].validate()){
                        console.log("director belum valid");
                        is_valid = false;
                    }
                }

                if(is_valid){
                    for(let i=0;i<this.director_list.length;i++){
                        let ref = 'director'+this.director_list[i].id;
                        this.$refs[ref][0].uploadFile();
                    }     
                }
                else{
                    this.isLoading = false;
                }
            }
        },
        mounted() {
            this.init = false;
            let self = this;
            this.$nextTick(() => {
                CreateAccount.list({start:0, length:-1}).then((response)=>{
                    if (response.status == 200) {
                        
                        if(response.data.data.length>0){
                            self.account_id = response.data.data[0]['id'];
                            self.user_no = response.data.data[0]['userNo'];
                            self.information = response.data.data[0]['information'];
                            
                            if(this.information['directorIdNo']){
                                this.director_list = [];
                                for(let i=0;i<this.information['directorIdNo'].length;i++){
                                    this.director_list.push({
                                        "id":(i+1),
                                        "is_new":false
                                    });
                                }
                            }
                        }

                        this.init = true;
                    }
                });
            });
        },
    };
  </script>